export class CouponSessionUser {
  public firstName: string;
  public lastName: string;
  public gender: string;
  public phone: string;
  public email: string;
}
